export default __webpack_public_path__ + "static/media/close.84cb05a3.svg";